export function uid(prefix = "n"): string {
  const t = Math.floor(Date.now() / 1000).toString(36);
  const r = Math.random().toString(36).slice(2, 9);
  return `${prefix}_${t}_${r}`;
}

